import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { App } from "./App";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
// import 'module-alias/register';
// import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { SnackbarProvider } from "notistack";
// import Swal from "sweetalert2";
import SWDebugPanel from "./sw-debug-panel";


const client = new QueryClient({
  defaultOptions: {
    queries: {
      // Configuración para trabajo offline
      retry: (failureCount, error: any) => {
        // No reintentar si estamos offline y es un error de red
        if (!navigator.onLine && error?.name === "TypeError") {
          return false;
        }
        return failureCount < 3;
      },
      staleTime: 5 * 60 * 1000, // 5 minutos
      cacheTime: 10 * 60 * 1000, // 10 minutos (antes cacheTime)
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <QueryClientProvider client={client}>
    {/* <ReactQueryDevtools/> */}
    <SnackbarProvider maxSnack={3} hideIconVariant={false} dense>
      {/* <ServiceWorkerWrapper /> */}
      <SWDebugPanel />
      <App />
    </SnackbarProvider>
  </QueryClientProvider>
);
